var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconFilters(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 7.688a.75.75 0 0 1 .75.75v8.437a.75.75 0 0 1-1.5 0V8.437a.75.75 0 0 1 .75-.75zM10 2.375a.75.75 0 0 1 .75.75v2.188a.75.75 0 0 1-1.5 0V3.124a.75.75 0 0 1 .75-.75z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 6.063a.813.813 0 1 0 0 1.625.813.813 0 0 0 0-1.625zm-2.313.812a2.312 2.312 0 1 1 4.625 0 2.312 2.312 0 0 1-4.624 0zM15.625 13.938a.75.75 0 0 1 .75.75v2.187a.75.75 0 0 1-1.5 0v-2.188a.75.75 0 0 1 .75-.75zM15.625 2.375a.75.75 0 0 1 .75.75v8.438a.75.75 0 0 1-1.5 0V3.124a.75.75 0 0 1 .75-.75z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.625 12.313a.813.813 0 1 0 0 1.625.813.813 0 0 0 0-1.626zm-2.313.812a2.312 2.312 0 1 1 4.625 0 2.312 2.312 0 0 1-4.625 0zM4.375 11.438a.75.75 0 0 1 .75.75v4.687a.75.75 0 0 1-1.5 0v-4.688a.75.75 0 0 1 .75-.75zM4.375 2.375a.75.75 0 0 1 .75.75v5.937a.75.75 0 1 1-1.5 0V3.126a.75.75 0 0 1 .75-.75z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.375 9.813a.813.813 0 1 0 0 1.625.813.813 0 0 0 0-1.626zm-2.313.812a2.312 2.312 0 1 1 4.625 0 2.312 2.312 0 0 1-4.625 0z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFilters);
export default __webpack_public_path__ + "static/media/icon-filters.5a519df3.svg";
export { ForwardRef as ReactComponent };